import { render, staticRenderFns } from "./ServiceRecordGrid.vue?vue&type=template&id=35454296"
import script from "./ServiceRecordGrid.vue?vue&type=script&lang=js"
export * from "./ServiceRecordGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports